import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    q: "What does an independent insurance broker do?",
    a: "Unlike captive agents who sell for one carrier, independent brokers like Mom & Pop shop the entire market. We compare rates from 30+ carriers to find the best coverage at the best price for your specific situation.",
  },
  {
    q: "How much does it cost to get a quote?",
    a: "Nothing. Our quotes are 100% free with no obligation. We're compensated by the insurance carrier you choose, so our service costs you nothing extra.",
  },
  {
    q: "What states are you licensed in?",
    a: "We're currently licensed in Arizona, Texas, North Carolina, Illinois, Arkansas, and California. Our primary focus is Arizona, where we serve over 100 communities.",
  },
  {
    q: "How fast can I get coverage?",
    a: "In many cases, we can bind coverage the same day you request a quote. Most clients receive their personalized comparison within 1 business hour.",
  },
  {
    q: "Do you offer commercial insurance for small businesses?",
    a: "Absolutely. We specialize in small business insurance including general liability, BOP policies, workers' compensation, commercial auto, and group employee benefits.",
  },
  {
    q: "Can you help with group health insurance for my employees?",
    a: "Yes — group benefits is one of our highest-priority services. We help Arizona employers of all sizes find competitive health, dental, vision, and life insurance packages.",
  },
];

const FAQSection = () => {
  return (
    <section className="py-16 md:py-24">
      <div className="container max-w-3xl">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold mb-3">Frequently Asked Questions</h2>
          <p className="text-muted-foreground">Common questions about working with an independent broker.</p>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {faqs.map((faq, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="bg-surface rounded-xl shadow-card px-6 border-0"
            >
              <AccordionTrigger className="text-left text-sm font-semibold hover:no-underline py-5">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm text-muted-foreground leading-relaxed pb-5">
                {faq.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
